import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Input } from "components/atoms/Input";
import { Select } from "components/atoms/Select";
import { Toggle } from "components/atoms/Toggle";
import { FilterFieldDTO } from "types";
import { Label } from "utils/styling/typography.styled";
import * as Styled from "./SearchAccordion.styled";
type SearchAccordionProps = {
  filterFields: FilterFieldDTO[];
  filters: Record<string, any>;
  handleFilterChange: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => void;
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  sort: string;
  setSort: React.Dispatch<React.SetStateAction<string>>;
  sortOrder: string;
  setSortOrder: React.Dispatch<React.SetStateAction<string>>;
  disabledFilters?: string[];
};
const SearchAccordion: React.FC<SearchAccordionProps> = ({
  filterFields,
  filters,
  handleFilterChange,
  query,
  setQuery,
  sort,
  setSort,
  sortOrder,
  setSortOrder,
  disabledFilters = []
}) => {
  const renderFilterFields = () => {
    return filterFields.map(field => {
      const isDisabled = disabledFilters.includes(field.label);
      if (field.isFreeText) {
        return <Styled.FormControl key={field.label}>
                        <Label>{field.label}</Label>
                        <Input type="text" name={field.label} value={filters[field.label] || ""} onChange={handleFilterChange} placeholder={`${field.label}...`} disabled={isDisabled} />
                    </Styled.FormControl>;
      } else if (field.isCheckbox) {
        return <Styled.CheckboxContainer key={field.label}>
                        <Label>{field.label}</Label>
                        <Toggle id={field.label} name={field.label} checked={filters[field.label]} onChange={handleFilterChange} disabled={isDisabled} />
                    </Styled.CheckboxContainer>;
      } else {
        return <Styled.FormControl key={field.label}>
                        <Label>{field.label}</Label>
                        <Select name={field.label} value={filters[field.label] || ""} onChange={handleFilterChange} disabled={isDisabled}>
                            <Styled.MenuItem value="">All</Styled.MenuItem>
                            {field.values.map(option => <Styled.MenuItem key={option} value={option}>
                                    {option}
                                </Styled.MenuItem>)}
                        </Select>
                    </Styled.FormControl>;
      }
    });
  };
  return <Styled.StyledAccordionContainer data-sentry-element="unknown" data-sentry-component="SearchAccordion" data-sentry-source-file="index.tsx">
            <Styled.StyledAccordion data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.StyledAccordionSummary expandIcon={<ExpandMoreIcon style={{
        color: "white"
      }} />} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.AccordionTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">Filter</Styled.AccordionTitle>
                </Styled.StyledAccordionSummary>
                <Styled.StyledAccordionDetails data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Input type="text" name="query" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search..." data-sentry-element="Input" data-sentry-source-file="index.tsx" />
                    <Styled.SortFilterContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        <Styled.LabelContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            <Label data-sentry-element="Label" data-sentry-source-file="index.tsx">Sort By</Label>
                            <Styled.SearchSelect value={sort} onChange={e => setSort(e.target.value)} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                <Styled.MenuItem value="createdAt" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Most Recent
                                </Styled.MenuItem>
                                <Styled.MenuItem value="highestRated" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Highest Rated (All Time)
                                </Styled.MenuItem>
                                <Styled.MenuItem value="highestRatedHour" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Highest Rated (Hour)
                                </Styled.MenuItem>
                                <Styled.MenuItem value="highestRatedDay" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Highest Rated (Day)
                                </Styled.MenuItem>
                                <Styled.MenuItem value="highestRatedWeek" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Highest Rated (Week)
                                </Styled.MenuItem>
                                <Styled.MenuItem value="highestRatedMonth" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Highest Rated (Month)
                                </Styled.MenuItem>
                                <Styled.MenuItem value="highestRatedYear" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Highest Rated (Year)
                                </Styled.MenuItem>
                            </Styled.SearchSelect>
                        </Styled.LabelContainer>
                        <Styled.LabelContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            <Label data-sentry-element="Label" data-sentry-source-file="index.tsx">Order</Label>
                            <Styled.SearchSelect value={sortOrder} onChange={e => setSortOrder(e.target.value)} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                <Styled.MenuItem value="asc" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Asc
                                </Styled.MenuItem>
                                <Styled.MenuItem value="desc" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                                    Desc
                                </Styled.MenuItem>
                            </Styled.SearchSelect>
                        </Styled.LabelContainer>
                    </Styled.SortFilterContainer>
                </Styled.StyledAccordionDetails>
                <Styled.StyledAccordionDetails data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    {renderFilterFields()}
                </Styled.StyledAccordionDetails>
            </Styled.StyledAccordion>
        </Styled.StyledAccordionContainer>;
};
export default SearchAccordion;